import { useState } from "react";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email.trim() === "") {
            setMessage("Please enter your email address.");
        } else {
            // Simulate API call
            setMessage("Password reset link has been sent to your email.");
        }
    };

    return (
        <div className="login-sec">
            <div className="login-form-sec">
                <form onSubmit={handleSubmit}>
                    <div className="login-form">
                        <h1 className="heading1">Reset Password</h1>
                        <div className="frm-group">
                            <label className="frm-label">Email</label>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="frm-input"
                            />
                            {/* <div className="input-error">Please inter Email</div> */}
                        </div>
                        <div className="logbtn-group mt-4">
                            <button type="submit" className="btn-black w-100">Send Reset Link</button>
                        </div>
                        <div className="forgotlink-row">
                            {message && <p className="forgot-message">{message}</p>}
                        </div>
                        <div className="forgot-links mt-3 text-end">
                            <Link to="/login">Back to Login</Link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
